<template>
	<header class="header">
		<slot></slot>
		<div v-if="name && canClose" class="close">
			<button type="button" class="unbutton" @click="$modal.hide(name)">
				<svg-close/>
			</button>
		</div>
	</header>
</template>

<script>
export default {
	props : {
		name : {
			type    : String,
			default : ''
		},
		canClose : {
			type    : Boolean,
			default : true
		}
	}
}
</script>
